
<div class="pager" *ngIf="pageCount > 1">
	<div class="page" *ngIf="page > 1"><span (click)="goToPage(1)">&laquo;</span>&nbsp;<span (click)="goToPage(page - 1)">&lsaquo;</span></div>
	<div class="page" *ngFor="let p of pages" (click)="goToPage(p)" [ngClass]="{active: p == page}">{{p}}</div>
	<div class="page" *ngIf="page < pageCount"><span (click)="goToPage(page + 1)">&rsaquo;</span>&nbsp;<span (click)="goToPage(pageCount)">&raquo;</span></div>
</div>